<template>
  <div class="header-title">
    <div @click="$emit('click')" class="header-title__title mb-5">
      <slot></slot>
    </div>

    <div class="header-title__subtitle" v-if="$slots['subtitle']">
      <slot name="subtitle"></slot>
    </div>
  </div>
</template>

<style lang="scss">
.header-title {
  &__title {
    display: flex;
    align-items: center;
    font-size: $questionnaire-form-title-font-size;
    font-weight: $font-bold;
  }

  &__subtitle {
    font-size: $heading-5-size;
    padding-left: 0;
    max-width: 100%;
    color: $text-color-less;
  }
}
</style>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({ emits: ["click"] });
</script>
